/* eslint-env browser */

import { Controller } from '@hotwired/stimulus'
import { randomString } from '../../../../utils/random'

export default class extends Controller {
  static targets = ['deviceId']

  connect () {
    this.deviceIdTarget.value = this.#deviceId
  }

  get #deviceId () {
    try {
      const deviceId = localStorage.getItem('deviceId')
      if (deviceId) { return deviceId }

      localStorage.setItem('deviceId', randomString())
      return localStorage.getItem('deviceId')
    } catch (error) {
      console.warn('Failed to access localStorage:', error)
      return null
    }
  }
}
